/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Knowledge_MethodologyInputs */

const en_directory_knowledge_methodology = /** @type {(inputs: Directory_Knowledge_MethodologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curated from first-party sources and verified evidence records. Confidence and check dates are recorded per item.`)
};

const zh_directory_knowledge_methodology = /** @type {(inputs: Directory_Knowledge_MethodologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于第一方来源与已验证证据记录整理，每项均记录置信度与核查日期。`)
};

/**
* | output |
* | --- |
* | "Curated from first-party sources and verified evidence records. Confidence and check dates are recorded per item." |
*
* @param {Directory_Knowledge_MethodologyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_knowledge_methodology = /** @type {((inputs?: Directory_Knowledge_MethodologyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Knowledge_MethodologyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_knowledge_methodology(inputs)
	return zh_directory_knowledge_methodology(inputs)
});
export { directory_knowledge_methodology as "directory.knowledge.methodology" }